import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setCompanyRoleType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const CompanyRoleTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Sector"
      id="company_role_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setCompanyRoleType(option.id))
      }}
    />
  )
}
export default CompanyRoleTypeDropdown
